export default __webpack_public_path__ + "static/media/buy-vocals.6b41a0d6.jpg";